import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { CustomTagManager } from '../utils/GTM';
import {
  handleClickPhotoDownload,
  handleClickTimelapseDownload,
  handleClickVideoDownload,
} from '../utils/downloadHandler';
import {
  StyledButton,
  StyledButtonContainer,
} from './styles/downloadButton.style';
import TryAgainToast from './TryAgainToast';

const defaultButtonColor = {
  $backgroundColor: '#ffffff',
  $textColor: '#ffffff',
  $iconColor: '#ffffff',
  $borderGradientTop: '#ffffff',
  $borderGradientBottom: '#ffffff',
};

const DownloadButtons = ({
  buttonColor = defaultButtonColor,
  sessionId,
  photoDownloadCallback,
  videoDownloadCallback,
  timelapseDownloadCallback,
}) => {
  const { t } = useTranslation();
  const [showToast, setShowToast] = useState(false);

  const showErrorToastMessage = () => {
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 2000);
  };

  return (
    <>
      <StyledButtonContainer>
        <StyledButton
          {...buttonColor}
          onClick={() => {
            handleClickPhotoDownload(sessionId, showErrorToastMessage).then(
              () => {
                CustomTagManager.QR_Download_Page_Download_Photo_Clicked();
                if (photoDownloadCallback) {
                  photoDownloadCallback();
                }
              },
            );
          }}
        >
          <i className="image" />
          <span>{t('PHOTO_DOWNLOAD')}</span>
        </StyledButton>
        <StyledButton
          {...buttonColor}
          onClick={() => {
            handleClickVideoDownload(sessionId, showErrorToastMessage).then(
              () => {
                CustomTagManager.QR_Download_Page_Download_Video_Clicked();
                if (videoDownloadCallback) {
                  videoDownloadCallback();
                }
              },
            );
          }}
        >
          <i className="video" />
          <span>{t('VIDEO_DOWNLOAD')}</span>
        </StyledButton>
        <StyledButton
          {...buttonColor}
          onClick={() => {
            handleClickTimelapseDownload(sessionId, showErrorToastMessage).then(
              () => {
                CustomTagManager.QR_Download_Page_Download_Timelapse_Clicked();
                if (timelapseDownloadCallback) {
                  timelapseDownloadCallback();
                }
              },
            );
          }}
        >
          <i className="timelapse" />
          <span>{t('TIMELAPSE_DOWNLOAD')}</span>
        </StyledButton>
      </StyledButtonContainer>

      {showToast && <TryAgainToast />}
    </>
  );
};

export default DownloadButtons;
